import type { MobileStripVariantConfig } from "./stripVariants"

// The current story year in the variant's corner. dateStyle picks how
// loud it is — bare text, or a pill that tops the visual hierarchy.
export const StripDateLabel = ({
  config,
  year,
  textColor,
  backgroundColor,
}: {
  config: MobileStripVariantConfig
  year: number
  textColor: string
  backgroundColor: string
}) => {
  const cornerClass = config.datePillPlacement === "top-left"
    ? "left-2.5 top-2"
    : "bottom-2 right-2.5"
  if (config.dateStyle === "text") {
    return (
      <div
        className={`absolute font-mono text-xs font-bold leading-none ${cornerClass}`}
        style={{ color: textColor }}
      >
        {year}
      </div>
    )
  }
  return (
    <div
      className={`absolute rounded-full font-mono font-bold leading-none ${cornerClass}`}
      style={{
        fontSize: config.datePillFontPx,
        padding: `${config.datePillPaddingPx.y}px ${config.datePillPaddingPx.x}px`,
        ...(config.dateStyle === "pill-filled"
          ? { backgroundColor: textColor, color: backgroundColor }
          : {
              // Outlined pill on a page-background plate (transparent
              // let the dither show through inside the outline).
              backgroundColor,
              color: textColor,
              border: `1.5px solid ${textColor}`,
            }),
      }}
    >
      {year}
    </div>
  )
}
